import { HelpCircle, Info, MessageSquare, Settings2, Store, Folders } from 'lucide-react';
import { SuiteHero } from './SuiteHero';
import { RecentlyUsed } from './RecentlyUsed';
import { CategorySection } from './CategorySection';
import { ToolCard } from './ToolCard';
import { useVisibleSuitePlugins } from './useVisibleSuitePlugins';
import { pluginRegistry } from '@/plugins/pluginRegistry';

export function SuiteDashboard() {
  const {
    visibleAnalysis,
    visibleData,
    visibleAdmin,
    totalVisible,
  } = useVisibleSuitePlugins();
  const helpEnabled = pluginRegistry.isPluginEnabled('help-assistant');

  return (
    <div className="p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl space-y-6">
        <SuiteHero visibleToolCount={totalVisible} />

        <RecentlyUsed />

        <div className="space-y-6">
          <CategorySection group="analysis" plugins={visibleAnalysis} />
          <CategorySection group="data" plugins={visibleData} />
          <CategorySection group="admin" plugins={visibleAdmin} />

          {/* Konfiguration — hardcoded (kein Plugin) */}
          <section data-testid="category-configuration">
            <div className="mb-3">
              <h2 className="text-sm font-semibold">Konfiguration</h2>
              <p className="text-xs text-muted-foreground">Plattform und Integrationen verwalten</p>
            </div>
            <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
              <ToolCard
                id="marketplace"
                name="Sopho Marketplace"
                description="Plugins entdecken, freischalten und verwalten"
                icon={Store}
                href="/app/plugins/marketplace"
              />
              <ToolCard
                id="workspaces"
                name="Sopho Workspaces"
                description="Workspaces anlegen, wechseln und organisieren"
                icon={Folders}
                href="/app/workspaces"
              />
              <ToolCard
                id="settings"
                name="Sopho Settings"
                description="Langflow, AI-Modelle, Vektordatenbank und Sicherheit konfigurieren"
                icon={Settings2}
                href="/app/settings"
              />
              <ToolCard
                id="feedback"
                name="Sopho Feedback"
                description="Rückmeldungen und Produktfeedback werden demnächst verfügbar"
                icon={MessageSquare}
                badge="Demnächst"
                disabled
              />
              <ToolCard
                id="help"
                name="Sopho Help"
                description="Schnellstart, Funktionen und geführte Unterstützung öffnen"
                icon={HelpCircle}
                href={helpEnabled ? '/app/help' : undefined}
                badge={helpEnabled ? undefined : 'Inaktiv'}
                badgeVariant="outline"
                disabled={!helpEnabled}
              />
              <ToolCard
                id="info"
                name="Sopho Info"
                description="Produkt- und Systeminformationen werden demnächst verfügbar"
                icon={Info}
                badge="Demnächst"
                disabled
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
